import {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";
import styles from "../marketing.module.scss";
import Video from "../../../../resources/img/Events/Marketing/sec13_video_m.mp4";

export const Section13 = (props) => {
    const [frame, setFrame] = useState(0)
    const spring = useSpring({ x: frame })

    useEffect(() => {
        if (!props.ranges?.length || props.ranges[0].length < 2) return
        const currentFrame = props.run(props)
        // console.log(currentFrame)
        setFrame(currentFrame)
    }, [props.pageYOffset, props.innerHeight])

    return (
        <animated.div className={styles['animation-container']} style={{
            opacity: spring.x.to({
                range: props.section.opacityRange as number[],
                output: props.section.opacityOutput as number[]
            }).to(x => x),
        }}>
            <div className={`${styles.sec} ${styles.sec13} ${styles.rel}`}>
                <video className={styles.sec13__video} muted autoPlay playsInline loop>
                    <source src={Video} type="video/mp4" />
                </video>
                <animated.p className={`${styles.sec13__font01} ${styles.ab} ${styles.notoBold} ${styles.marginDel}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.05, 1],
                        output: [0, 1, 1]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.05, 0.95, 1],
                        output: [10, 0, 0, -10]
                    }).to(x => `${x}vh`)
                }}>상승장</animated.p>
                <animated.p className={`${styles.sec13__font03} ${styles.ab} ${styles.notoBold} ${styles.marginDel}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.3, 0.4, 1],
                        output: [0, 0, 1, 1]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.3, 0.4, 0.95, 1],
                        output: [-10, -10, 0, 0, -10]
                    }).to(x => `${x}vh`)
                }}>하락장</animated.p>
                <animated.p className={`${styles.sec13__font05} ${styles.ab} ${styles.notoBold} ${styles.marginDel}`} style={{
                    left: spring.x.to({
                        range: [0, 0.6, 0.7, 0.95, 1],
                        output: [38, 38, 21, 21, 21]
                    }).to(x => `${x}vw`),
                    opacity: spring.x.to({
                        range: [0, 0.6, 0.7, 1],
                        output: [0, 0, 1, 1]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.6, 0.7, 0.95, 1],
                        output: [0, 0, 0, 0, -10]
                    }).to(x => `${x}vh`)
                }}>횡보장에도</animated.p>
            </div>
        </animated.div>
    )
}